import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';


/**
 * Dialog content can be scrollable.
 */
export default class Grading extends React.Component {
  state = {
    open: false,
  };

  handleOpen = () => {
    this.setState({open: true});
  };

  handleClose = () => {
    this.setState({open: false});
  };

  render() {
    const actions = [
      <FlatButton
        label="OK"
        keyboardFocused={true}
        primary={true}
        onClick={this.handleClose}
      />
    ];

    const dialogArray = [

    ]

    return (

      <div>


        <div>
        <RaisedButton label="Submit" onClick={this.handleOpen} style = {{marginLeft: 120}} />
        </div>

        <Dialog
          title="You missed:"
          actions={actions}
          modal={false}
          open={this.state.open}
          onRequestClose={this.handleClose}
          autoScrollBodyContent={true}
        >

          {//using props that you get from Aa1Info.js to check if they are the correct answers
            }
          {this.props.alanine == "alanine" ? null : <div> A </div> }
          {this.props.arginine == "arginine" ? null : <div> R </div>}
          {this.props.asparagine == "asparagine" ? null : <div> N </div>}
          {this.props.aspartate == "aspartic acid" ? null : <div> D </div>}
          {this.props.cystine == "cysteine" ? null : <div> C </div>}
          {this.props.glutamate == "glutamic acid" ? null : <div> E </div>}
          {this.props.glutamine == "glutamine" ? null : <div> Q </div>}
          {this.props.glycine == "glycine" ? null : <div> G </div>}
          {this.props.histidine == "histidine" ? null : <div> H </div>}
          {this.props.isoleucine == "isoleucine" ? null : <div> I </div>}
          {this.props.leucine == "leucine" ? null : <div> L </div>}
          {this.props.lysine == "lysine" ? null : <div> K </div>}
          {this.props.methionine == "methionine" ? null : <div> M </div>}
          {this.props.phenylalanine == "phenylalanine" ? null : <div> F </div>}
          {this.props.proline == "proline" ? null : <div> P </div>}
          {this.props.serine == "serine" ? null : <div> S </div>}
          {this.props.threonine == "threonine" ? null : <div> T </div>}
          {this.props.tryptophan == "tryptophan" ? null : <div> W </div>}
          {this.props.tyrosine == "tyrosine" ? null : <div> Y </div>}
          {this.props.valine == "valine" ? null : <div> V </div>}


          {//if the user gets all the questions right, then he will get a response saying none
            this.props.alanine == "alanine" && this.props.arginine == "arginine" && this.props.asparagine == "asparagine"
          && this.props.aspartate == "aspartic acid" && this.props.cystine == "cysteine" && this.props.glutamate == "glutamic acid"
          && this.props.glutamine == "glutamine" && this.props.glycine == "glycine" && this.props.histidine == "histidine"
          && this.props.isoleucine == "isoleucine" && this.props.leucine == "leucine"
          && this.props.lysine == "lysine" && this.props.methionine == "methionine" && this.props.phenylalanine == "phenylalanine"
          && this.props.proline == "proline" && this.props.serine == "serine" && this.props.threonine == "threonine"
          && this.props.tryptophan == "tryptophan" && this.props.tyrosine == "tyrosine" && this.props.valine == "valine"
          ? <div> Nothing, good work. </div> : null}





        </Dialog>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/grading.js